export const isValidWaveformSVG = svg => {
  // Lowercase everything for case-insensitive comparison
  svg = svg.toLowerCase()

  // Ensure it starts with <svg and ends with </svg>
  if (!svg.startsWith('<svg') || !svg.endsWith('</svg>')) {
    return false
  }

  // Check for event handler attributes
  if (/\son\w*=/g.test(svg)) {
    return false // Fail validation if any event handlers are found
  }

  // Remove all instances of allowed tags to see if anything else is left over
  const cleanedSvg = svg
    .replace(/<\/?(svg|rect|path)[^>]*>/g, '') // Remove allowed tags
    .replace(/\s+/g, '') // Remove whitespace to ignore spaces between tags

  // If anything other than whitespace is left, it's an invalid tag
  if (cleanedSvg.trim().length > 0) {
    return false
  }

  // The SVG is valid if it only contains allowed tags, no event handlers, and passes the above checks
  return true
}
